import React from "react";

const BlogPost = ({ title, content, author, createdAt, slug }) => {
    return (
        <div className="blog-post border rounded-lg p-4 mb-6">
            <h3 className="text-2xl font-bold">{title}</h3>
            <p className="text-sm text-gray-500">By {author} on {new Date(createdAt).toLocaleDateString()}</p>
            <div className="blog-content mt-4">
                {content.map((section, index) => {
                    switch (section.type) {
                        case "text":
                            return <p key={index} dangerouslySetInnerHTML={{ __html: section.content }} />;
                        case "image":
                            return (
                                <img
                                    key={index}
                                    src={section.src}
                                    alt={section.alt}
                                    className={`my-4 ${section.className || ""}`}
                                    style={section.style || {}}
                                />
                            );
                        case "list":
                            return (
                                <ul key={index} className="list-disc pl-5 my-4">
                                    {Array.isArray(section.content) &&
                                        section.content.map((item, listIndex) => (
                                            <li key={listIndex}>{item}</li>
                                        ))}
                                </ul>
                            );
                        case "quote":
                            return (
                                <blockquote key={index} className="italic text-gray-600 my-4">
                                    {section.content}
                                </blockquote>
                            );
                        default:
                            return null;
                    }
                })}
            </div>
            <div className="social-links flex flex-col md:flex-row md:flex-wrap mt-4">
                <a
                    href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                        window.location.href
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-blue-600 text-white mb-2 md:mb-0 md:mr-2 px-4 py-2 rounded w-full md:w-auto text-center"
                >
                    Share on Facebook
                </a>
                <a
                    href={`https://wa.me/?text=${encodeURIComponent(
                        window.location.href
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-green-500 text-white mb-2 md:mb-0 md:mr-2 px-4 py-2 rounded w-full md:w-auto text-center"
                >
                    Share on WhatsApp
                </a>
                <a
                    href={`https://www.reddit.com/submit?url=${encodeURIComponent(
                        window.location.href
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-orange-500 text-white mb-2 md:mb-0 md:mr-2 px-4 py-2 rounded w-full md:w-auto text-center"
                >
                    Share on Reddit
                </a>
                <a
                    href={`https://mail.google.com/mail/u/0/?view=cm&to&su=Awesome+Post!&body=${encodeURIComponent(
                        window.location.href
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-red-500 text-white mb-2 md:mb-0 px-4 py-2 rounded w-full md:w-auto text-center"
                >
                    Share via Email
                </a>
            </div>
            <p className="text-blue-600 text-sm mt-4">
                Link:{" "}
                <a href={`/blog/${slug}`} target="_blank" rel="noopener noreferrer">
                    {`/blog/${slug}`}
                </a>
            </p>
        </div>
    );
};

export default BlogPost;
